import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=a7b38f06&scoped=true&"
import script from "./AskQuestion.vue?vue&type=script&lang=js&"
export * from "./AskQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AskQuestion.vue?vue&type=style&index=0&id=a7b38f06&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b38f06",
  null
  
)

export default component.exports